<!-- 
  Injects a custom component into the date range picker overlay via the 
  `calendarHeaderComponent` input. Despite the name, the component is not 
  limited to rendering a header—it can include forms, panels, and other 
  elements positioned absolutely relative to the calendar.

  DateRangeOverlayContent is used to extend the overlay with custom controls 
  and UI enhancements.
-->
<mat-date-range-picker
  #picker
  panelClass="atn-ds-date-range-overlay"
  [calendarHeaderComponent]="DateRangeOverlayContent"
>
  <mat-date-range-picker-actions>
    <atn-ds-button
      type="transparent"
      (click)="cancelClickHandler()"
    >
      Cancel
    </atn-ds-button>
    <atn-ds-button (click)="applyClickHandler()"> Apply </atn-ds-button>
  </mat-date-range-picker-actions>
</mat-date-range-picker>
